export const duplicatePaymentMessage =
  "You are trying to make same payment within in a time window, please login back in sometime";
export const currentBalanceNotAvailable = "0.00";
export const estimatedNewChargesNotAvailable = "0.00";
export const nextBillingDateNotAvailable = "Not Available";
export const maxLengths = {
  cardNumber: 19,
  expiryDate: 5,
  postalCode: 10,
  cvv: 4
};
export const smallScreenHeading = {
  PayRent: "Pay Rent",
  BalanceDetail: "Your Balance Details"
};
export const formLabels = {
  mainLabel: "Card Information",
  creditCardLabel: "Credit Card Number",
  expiryDateLabel: "Expiry Date",
  holderInfoLabel: "Cardholder Information",
  nameLabel: "Name",
  addressLabel: "Address",
  existingCardInfoLabel: "Existing Card Information"
};
export const accessCodeAlertBarMessages = {
  line1: "Your access code has been disabled. ",
  line2: "Please pay the past due balance to restore access."
};
export const smallScreenIconSize = "16";
export const existingCardsSectionLabels = {
  useExistingLabel: "Use existing card for payment",
  useNewLabel: "Use new card for payment"
};
export const billingDetailsLabels = {
  sectionLabel: "Billing Details",
  balance: "Current Balance Due",
  newCharges: "Estimated New Charges",
  billingDate: "Next Billing Date"
};
export const successScreenLabels = {
  mainLabel: "Payment Success",
  amountLabel: "Total payable amount:",
  authLabel: "Authorization Code:",
  currBalanceLabel: "Current Balance Due:",
  buttonLabel: "Pay Again",
  paymentMessage:
    "Thank you for your payment! A receipt for this transaction has been sent to"
};

export const failureScreenLabels = {
  duplicatePaymentMessage:
    "You are trying to make same payment within in a time window, please login back in sometime",
  buttonLabel: "Back"
};
export const transactionHelpersLabels = {
  customer_type_ledger: "Tenant_With_Ledger",
  client_type_front_end: "Front_End",
  online: "Online",
  cash: "Cash",
  cheque: "Cheque",
  offline: "Offline",
  transactionSubSectionLabel: "Recent Transaction Details",
  tableColumnsLabels: {
    col1: "From Date",
    col2: "To Date",
    col3: "Amount Paid",
    col4: "Charge Type",
    col5: "Method"
  }
};
export const checkBalanceLabels = {
  balanceDetailsMainLabel: "Balance Details",
  currency_sign_dollar: "$",
  balanceSectionLabel: "Outstanding Balance",
  paymentSectionLabel: "Last Payment Amount",
  paymentDateLabel: "Last Payment Date",
  buttonText: "Make a Payment",
  unitSectionLabel: "Unit Details",
  noUnitsLabel: "No Unit is linked to this ledger"
};

export const updateContactLabels = {
  mainTitle: "Contact Information",
  contactFacility: " Please contact the facility to update your information.",
  cell_phone: "Cell_Phone"
};
export const payment_page_url = "../pay-rent";
export const autoPayPageLabels = {
  mainTitle: "Autopay",
  notEnabledMessage: ` You haven’t signed up for automatic payment yet.
  Please sign up for Automatic Payment on Pay Rent Screen while making your next payment`,
  paymentInfo: {
    mainLabel: "Card Information",
    cardNumberLabel: "Credit Card Number",
    expiryDateLabel: "Expiry Date",
    buttonLabel: "Deactivate Autopay"
  }
};
export const expiryNotificationConfigs = {
  content: "Session Expired!!! Please sign up again to continue",
  btnText: "Login"
};
export const LargeIconSize = 56;
export const MediumIconSize = 24;
export const amountResolutionType = {
  customAmount: "custom",
  balanceAmount: "balance"
};
export const paymentMethodType = {
  ach: "Ach",
  creditCard: "Credit_Card"
};
